import { registerComponent, getComponentConfig } from "helpers";

//get product title
let productTitle = document.querySelector(".product-details__title");
let getProductTitle = '';
if(productTitle !=  null ) getProductTitle = productTitle.innerText + " - Bambi Baby";
//console.log("getProductTilte- ", getProductTitle);

// Global array to track all video player instances
let allVideoPlayers = [];

// Function to stop all videos when switching thumbnails
function stopAllVideosOnThumbnailClick() {
  allVideoPlayers.forEach(player => {
    if (player.iframe) {
      player.stopVideo();
    }
  });
}

// Global function to stop all videos from anywhere in the application
function stopAllVideos() {
  console.log('Global stopAllVideos called');
  
  // Use the global allVideoPlayers array
  if (typeof allVideoPlayers !== 'undefined') {
    console.log('Found video players in global array:', allVideoPlayers.length);
    
    allVideoPlayers.forEach(player => {
      if (player.iframe) {
        console.log('Stopping video player:', player);
        player.stopVideo();
      }
    });
  }
  
  // Fallback: Find all video player instances and stop them
  const videoPlayers = document.querySelectorAll('video-player');
  console.log('Found video players via querySelector:', videoPlayers.length);
  
  videoPlayers.forEach(player => {
    if (player.iframe) {
      console.log('Stopping video player:', player);
      player.stopVideo();
    }
  });
  
  // Also try to stop videos by removing iframes directly
  const iframes = document.querySelectorAll('video-player iframe');
  iframes.forEach(iframe => {
    console.log('Removing iframe directly:', iframe);
    iframe.remove();
  });
  
  // Remove video-player--playing class from all video players
  const playingVideos = document.querySelectorAll('video-player.video-player--playing');
  playingVideos.forEach(video => {
    console.log('Removing playing class from:', video);
    video.classList.remove('video-player--playing');
  });
}

// Make the function globally available
window.stopAllVideos = stopAllVideos;

// Add event listener for thumbnail clicks when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Listen for clicks on product media secondary items (thumbnails)
  document.addEventListener('click', function(event) {
    const thumbnailItem = event.target.closest('.product-media__secondary-item');
    if (thumbnailItem) {
      console.log('Thumbnail clicked, stopping videos...');
      stopAllVideosOnThumbnailClick();
    }
  });
  
  // Listen for clicks on video players to stop other videos
  document.addEventListener('click', function(event) {
    const videoPlayer = event.target.closest('video-player');
    if (videoPlayer) {
      console.log('Video player clicked, stopping other videos...');
      // Stop all other videos before starting this one
      if (typeof allVideoPlayers !== 'undefined') {
        allVideoPlayers.forEach(player => {
          if (player !== videoPlayer && player.iframe) {
            player.stopVideo();
          }
        });
      }
    }
  });
});

registerComponent(
  "video-player",
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();

      this.config = getComponentConfig(this);
      
      // Add this instance to the global array
      allVideoPlayers.push(this);

      this.bindEvents();
    }

    // Static method to stop all other video players
    static stopAllOtherVideos(currentPlayer) {
      allVideoPlayers.forEach(player => {
        if (player !== currentPlayer && player.iframe) {
          player.stopVideo();
        }
      });
    }

    async fetchVimeoPreviewImageSrc() {
      const response = await fetch(
        `https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${this.config.id}&format=json&width=1200`
      );
      const data = await response.json();
      return data.thumbnail_url;
    }

    bindEvents() {
      this.renderPreviewImage();

      if (this.config.previewOnly) {
        return;
      }

      this.addEventListener("click", this.renderVideo.bind(this));
      this.handleModalContext();
    }

    async renderPreviewImage() {
      if (this.config.type === "youtube") {
        this.previewImageSrc = `https://i.ytimg.com/vi/${this.config.id}/maxresdefault.jpg`;
      } else {
        this.previewImageSrc = await this.fetchVimeoPreviewImageSrc();
      }

      this.previewButton = this.querySelector("[data-preview]");
      this.previewImage = document.createElement("img");
      this.previewImage.setAttribute("src", this.previewImageSrc);
      this.previewImage.setAttribute("alt", getProductTitle);
      this.previewImage.setAttribute(
        "class",
        "video-player__preview-image fit-image"
      );
      this.previewImage.setAttribute("loading", "lazy");
      this.previewButton.append(this.previewImage);
    }

    renderVideo() {
      // Stop all other videos before starting this one
      VideoPlayer.stopAllOtherVideos(this);

      if (this.config.type === "youtube") {
        this.videoSrc = `https://www.youtube.com/embed/${this.config.id}`;
      } else {
        this.videoSrc = `https://player.vimeo.com/video/${this.config.id}`;
      }

      this.iframe = document.createElement("iframe");
      const width = this.previewButton.offsetWidth;
      const height = this.previewButton.offsetHeight;

      this.iframe.setAttribute("src", `${this.videoSrc}?autoplay=1`);
      this.iframe.setAttribute("frameborder", "0");
      this.iframe.setAttribute("allowfullscreen", "1");
      this.iframe.setAttribute("allow", "autoplay; encrypted-media");
      this.iframe.setAttribute("class", "video-player__iframe fit-image");
      this.iframe.setAttribute("width", width);
      this.iframe.setAttribute("height", height);
      this.iframe.setAttribute("frameborder", "0");

      this.setAttribute("ready", true);
      this.appendChild(this.iframe);
      this.classList.add("video-player--playing");
    }

    // Method to stop the current video
    stopVideo() {
      if (this.iframe) {
        // For YouTube videos, we can stop them by changing the src to an empty string
        if (this.config.type === "youtube") {
          this.iframe.src = "";
        }
        // For Vimeo videos, we can also stop them by changing the src
        else if (this.config.type === "vimeo") {
          this.iframe.src = "";
        }
        
        this.iframe.remove();
        this.iframe = null;
        this.classList.remove("video-player--playing");
      }
    }

    handleModalContext() {
      const modal = this.closest("[data-modal]");

      if (modal) {
        modal.addEventListener("modalOpen", this.renderVideo.bind(this));
        modal.addEventListener("modalClose", this.reset.bind(this));
      }
    }

    reset() {
      if (this.iframe) {
        this.iframe.remove();
        this.iframe = null;
      }
      this.classList.remove("video-player--playing");
    }

    // Clean up when element is removed
    disconnectedCallback() {
      // Remove this instance from the global array
      const index = allVideoPlayers.indexOf(this);
      if (index > -1) {
        allVideoPlayers.splice(index, 1);
      }
    }
  }
);
